import { IContentBlockInstance } from '@/models/content-page.model';

export const replaceBlock = (
  blocks: IContentBlockInstance[],
  id: string,
  next: IContentBlockInstance,
): IContentBlockInstance[] => blocks.map((b) => (b.id === id ? next : b));

export const removeBlock = (blocks: IContentBlockInstance[], id: string): IContentBlockInstance[] =>
  blocks.filter((b) => b.id !== id);
